import React from 'react';

import { IntlUnitFormattingService } from '../../../../services/intl-unit-formatting-services/intl-unit-formatting-service';
import { WeightLabel } from '../../shared-field-labels/shared-field-labels';
import { useFulfillmentDisplayContext } from '../display-context';
import ReadonlyField from './readonly-field';

const Weight = () => {
  const { weight } = useFulfillmentDisplayContext();

  const formattedWeight = IntlUnitFormattingService.formatWeight(weight, weight.unit);

  return <ReadonlyField label={WeightLabel}>{formattedWeight}</ReadonlyField>;
};

export default Weight;
